export function capitalizeFullName(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
}

export const getStatusLabel = (status) => {
  switch (status) {
    case "posted":
      return "Posté";
    case "prestataire_selected":
      return "Prestataire choisi";
    case "refused":
      return "Refusé";
    case "canceled":
      return "Annulé";
    case "realised":
      return "Terminé";
  }
}